<div class="control my-4">
  <label class="checkbox">
    <input
      type="checkbox"
      class="checkmark"
      [checked]="checked"
      (change)="toggleCheck()"
    />
    {{ label }}
    @if (required) {
      <span class="required-indicator has-text-danger">*required</span>
    }
  </label>
  @if (helpText) {
    <p class="help mb-1">{{ helpText }}</p>
  }
</div>
